<template>
     <div>
        <div class="row">
            <div class="col-12">
                <div class="panel--bg">
                    <div class="panel__header"></div>
                    <div class="panel__body panel__body--review ">
                        <transition name="fade" mode="out-in">
                            <div v-if="newPasswordSent">
                                <h2>{{$t('forms.forgotten_password.sent')}}</h2>
                                <p>{{$t('forms..sent_text')}}</p>
                                <a class="button--cta" @click.prevent="changeAuthView('LoginForm')">{{$t('forms.forgotten_password.go_to_login')}}</a>
                            </div>
                            <form class="form" v-else>
                                <div class="alert--error" v-if="error.length > 0">{{error}}</div>
                                <h2>{{$t('auth.forgotten_password')}}</h2>

                                <p>{{$t('auth.message_forgotten_password')}}</p>

                                <div class="form__item">
                                    <i class="form__icon icons icon-envelope"></i>
                                    <input class="form__input--text" type="email" name="Email" :placeholder="$t('auth.hint_email')" v-model="email" />
                                    <label class="form__label">{{$t('forms.forgotten_password.email')}}</label>
                                </div>

                                <div class="form__buttons">
                                    <button class="button--cta small pull-right" @click.prevent="request">{{$t('auth.button_reset_password')}}</button>
                                    <router-link :to="{ name: 'sign-in'}" type="button" class="button--link pull-right-lg">{{$t('common.cancel')}}</router-link>
                                </div>
                            </form>
                        </transition>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    /* eslint-disable indent */

    import Vue from 'vue';
    import Component from 'vue-class-component';

    @Component
    export default class PasswordForgottenForm extends Vue {
        name = 'password-forgotten-form';
        newPasswordSent = false;

        email = '';
        error = '';
        /**
         * Request a new password
         */
        async request() {
            try {
                this.state = 'loading';
                let response = await this.axios.post(`/review-trajectory/${this.token}/reject`, {reason: this.rejectionReason});
                this.email = '';
                this.newPasswordSent = true;
            } catch (err) {
                this.error = this.$t('error');
                this.$notify.error(this.error);
            }
        }
    }

    Vue.component('password-forgotten-form', PasswordForgottenForm);
</script>



// WEBPACK FOOTER //
// src/components/auth/forms/PasswordForgottenForm.vue